import { roundProgressPercent } from '@/utils/levels';

type Props = {
  amountBet: number;
  amountTarget: number;
};

/**
 * Progresso de rollover pra exibição: % preenchida (0-100), rótulo
 * arredondado e "X DE Y" formatado. Extraído de InGameRollover.vue /
 * InGameRolloverDesktop.vue (faixa de rollover do header do jogo, ENG-817) —
 * as duas versões tinham o MESMO cálculo, só o template/CSS diverge entre
 * mobile e desktop.
 *
 * Recebe `props` (o objeto do `defineProps`, não desestruturado) pra manter
 * a reatividade: o computed aqui dentro lê `props.amountBet` a cada
 * recálculo, e não um valor capturado uma vez só no momento da chamada.
 */
export default function useRolloverProgress(props: Props) {
  const { showMoneyFormat } = useWallet();

  const progress = computed(() => {
    if (!props.amountTarget) return 0;

    return Math.max(
      0,
      Math.min(100, (props.amountBet / props.amountTarget) * 100),
    );
  });

  const progressLabel = computed(() => roundProgressPercent(progress.value));

  const amountLabel = computed(
    () =>
      `${showMoneyFormat({ value: props.amountBet })} DE ${showMoneyFormat({ value: props.amountTarget })}`,
  );

  return { progress, progressLabel, amountLabel };
}
